import payloadTypes from 'helpers/enums/interactiveVideo/payloadTypes'

function getActivityPayloadKey(activity) {
	return payloadTypes[activity.type]
}

function getActivityPayload(activity) {
	const activityPayloadKey = getActivityPayloadKey(activity)
	return activity[activityPayloadKey]
}

function getActivityByQuestionUid(activities, questionUid) {
	const activityIndex = findActivityIndexByUid(
		activities,
		questionUid,
	)
	return activities[activityIndex]
}

function findActivityIndexByUid(
	activities,
	activityUid,
) {
	return activities.findIndex(
		activity => {
			const activityPayload = activity[payloadTypes[activity.type]]
			return activityPayload.uid === activityUid
		}
	)
}

function updateActivitySharingOptions(activity, newSharingOptions) {
	const payloadKey = getActivityPayloadKey(activity)
	return {
		...activity,
		[payloadKey]: {
			...activity[payloadKey],
			sharingOptions: newSharingOptions,
		},
	}
}

export {
	findActivityIndexByUid,
	getActivityByQuestionUid,
	getActivityPayloadKey,
	getActivityPayload,
	updateActivitySharingOptions,
}
